import React from "react";

export default function Footer() {
  return (
    <div
      style={{
        background: "linear-gradient(180deg, #123F1F 0%, #04170D 100%)",
        color: "white",
        borderRadius: "32px 32px 0px 0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        flexDirection: "column",
        padding: "32px 32px",
        marginTop: "60px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1500px",
          height: "100%",
          display: "flex",
          alignItems: "flex-end",
          gap: "32px",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="footer-main-row">
          <div
            className="footer-text-column"
            style={{ fontSize: "16px", lineHeight: "1.6" }}
          >
            <p style={{ marginBottom: "12px" }}>
              Numbers.ag is a registered Commodity Trading Advisor (CTA) with
              the CFTC and a Member of the National Futures Association (NFA).
            </p>
            <p style={{ marginBottom: "12px" }}>
              There is a substantial risk of loss in futures trading. Past
              performance is not necessarily indicative of future results.
              Information is for informational purposes and should be one of
              many tools in your hedging plan.
            </p>
            <p style={{ marginBottom: "12px" }}>
              <strong>CFTC RULE 4.41:</strong>{" "}
              <em>
                Hypothetical performance results have many inherent limitations,
                some of which are described below. No representation is being
                made that any account will or is likely to achieve profits or
                losses similar to those shown; in fact, there are frequently
                sharp differences between hypothetical performance results and
                the actual results subsequently achieved by any particular
                trading program. One of the limitations of hypothetical
                performance results is that they are generally prepared with the
                benefit of hindsight. In addition, hypothetical trading does not
                involve financial risk, and no hypothetical trading record can
                completely account for the impact of financial risk of actual
                trading. For example, the ability to withstand losses or to
                adhere to a particular trading program in spite of trading
                losses are material points which can also adversely affect
                actual trading results. There are numerous other factors related
                to the markets in general or to the implementation of any
                specific trading program which cannot be fully accounted for in
                the preparation of hypothetical performance results and all
                which can adversely affect trading results.
              </em>
            </p>
            <p style={{ marginBottom: "8px" }}>
              <strong>AI RISK DISCLOSURE</strong>
            </p>
            <ul
              style={{
                margin: "0 0 0 20px",
                padding: 0,
                listStyleType: "disc",
              }}
            >
              <li style={{ marginBottom: "8px" }}>
                <strong>AI INTERPRETATION RISK:</strong> Numbers.ag utilizes AI
                to analyze market data; insights can occasionally contain
                "hallucinations." All AI analysis should be verified against raw
                data visuals before trading.
              </li>
              <li style={{ marginBottom: "8px" }}>
                <strong>ALGORITHMIC LIMITATIONS:</strong> AI patterns detected
                in historical data do not guarantee future movement. These
                insights are based on simulated analysis and do not represent
                actual live trading.
              </li>
              <li style={{ marginBottom: "0" }}>
                <strong>DECISION-SUPPORT ONLY:</strong> Numbers.ag AI is a
                support tool, not an automated system. Users retain full
                responsibility for all marketing and hedging decisions. AI does
                not account for your specific financial situation or local
                basis.
              </li>
            </ul>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            fontSize: "16px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "end" }}>
            © 2025 – CFTC Reports
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <a href="/privacy-policy" style={{ color: "white" }}>
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" style={{ color: "white" }}>
              Terms & Conditions
            </a>
            <a href="/ai-risk" style={{ color: "white" }}>
              AI Risk Disclaimer
            </a>
          </div>
        </div>

        <div
          style={{
            fontSize: "16px",
            color: "#CDD5D1",
            lineHeight: "1.6",
            marginTop: "24px",
            paddingTop: "24px",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <p style={{ marginBottom: "12px" }}>
            Numbers.ag is a registered Commodity Trading Advisor (CTA) with the
            CFTC and a Member of the National Futures Association (NFA).
          </p>
          <p style={{ marginBottom: "12px" }}>
            PAST PERFORMANCE: Past performance is not necessarily indicative of
            future results. Information is for informational purposes and should
            be one of many tools in your marketing or hedging plan.
          </p>
          <p>
            CFTC RULE 4.41: Hypothetical or simulated performance results have
            inherent limitations. Unlike an actual performance record, simulated
            results do not represent actual trading. Also, since the trades have
            not been executed, the results may have under-or-over compensated
            for the impact, if any, of certain market factors. No representation
            is being made that any account will achieve results similar to those
            shown.
          </p>
        </div>
      </div>
    </div>
  );
}
